
import { BlogSection } from '@/types/blog';

export const wissenstypen: BlogSection = {
  id: 'wissenstypen',
  title: 'Die fünf Arten von Wissenden',
  content: `
<p class="mb-6">
  Basierend auf einer alten persischen Weisheit möchte ich Ihnen fünf Arten von Menschen vorstellen, denen wir begegnen können, wenn wir Rat, Führung oder Coaching suchen:
</p>

<div class="space-y-6 mb-8">
  <div class="p-5 rounded-xl bg-joerg-50 border-l-4 border-joerg-300">
    <h3 class="text-lg font-medium mb-2">
      🔹 Menschen, die nicht wissen – und nicht einmal wissen, dass sie nicht wissen
    </h3>
    <p>
      Sie gehen durch die Welt wie Kinder: neugierig, offen, aber oft verloren. Sie erkennen nicht, wie begrenzt ihr Verständnis ist. Ihnen kann man mit Geduld begegnen und sie sanft zum Lernen anregen.
    </p>
  </div>
  
  <div class="p-5 rounded-xl bg-joerg-50 border-l-4 border-joerg-300">
    <h3 class="text-lg font-medium mb-2">
      🔹 Menschen, die erkennen, dass sie nicht wissen – und bereit sind zu lernen
    </h3>
    <p>
      Sie hören zu, stellen Fragen, nehmen Impulse auf. Mit ihnen kann man wachsen und einen gemeinsamen Weg beschreiten. Dies ist der Beginn wahrer Weisheit und ein fruchtbarer Boden für Coaching und Entwicklung. 💡
    </p>
  </div>
  
  <div class="p-5 rounded-xl bg-primary/10 border-l-4 border-destructive">
    <h3 class="text-lg font-medium mb-2 text-destructive-foreground">
      ⚠️ Menschen, die nicht wissen – aber denken, sie wüssten alles
    </h3>
    <p>
      Sie reden laut, belehren, ohne zu verstehen. Sie verwechseln ihre Meinungen mit Wahrheiten und ihre Überzeugungen mit Fakten. In der Welt der Finanzbildung, des Coachings und der persönlichen Entwicklung sind sie besonders gefährlich, denn sie können andere mit großer Überzeugungskraft in die Irre führen.
    </p>
  </div>
  
  <div class="p-5 rounded-xl bg-joerg-50 border-l-4 border-joerg-300">
    <h3 class="text-lg font-medium mb-2">
      🔹 Menschen, die wissen, aber vergessen haben, dass sie wissen
    </h3>
    <p>
      Sie schlafen in ihrem Wissen, ohne es zu leben. Sie haben Erfahrung und Einsicht gesammelt, aber greifen nicht mehr darauf zu. Vielleicht sind sie müde geworden oder haben den Kontakt zu ihrer inneren Weisheit verloren. Bei ihnen reicht manchmal ein sanftes Wecken, um wertvolle Begleiter zu werden. 🌱
    </p>
  </div>
  
  <div class="p-5 rounded-xl bg-joerg-50 border-l-4 border-primary">
    <h3 class="text-lg font-medium mb-2">
      🔹 Menschen, die wissen – und wissen, dass sie wissen
    </h3>
    <p>
      Sie tragen kein lautes Schild, sie missionieren nicht. Sie zeigen einfach durch ihr Sein und ihre behutsame Führung, dass sie verstehen. Ihnen musst du nicht blindlings folgen. Aber manchmal lohnt es sich, hinzuhören, wenn sie sprechen, und zu beobachten, wie sie handeln. 🎯
    </p>
  </div>
</div>

<p class="text-lg font-medium text-center my-8">
  🔹 Wähle weise, mit wem du gehst. 🔹
</p>
  `,
};
